import css from "./ViewButton.module.scss";

export default function ViewButton({ isSelected, onClick, label, icon }) {
    return (
        <div
            onClick={onClick}
            className={`${css["button"]} ${isSelected ? css["selected"] : ""}`}
        >
            <i className={`fas fa-${icon} ${css["icon"]}`} />
            <span className={css["label"]}>{label}</span>
        </div>
    );
}
